import cImg1 from "../images/casestudy/img01.jpg";
import cImg2 from "../images/casestudy/img02.jpg";
import cImg3 from "../images/casestudy/img03.jpg";
import cImg4 from "../images/casestudy/img04.jpg";
import cImg5 from "../images/casestudy/img05.jpg";
import cImg6 from "../images/casestudy/img06.jpg";
import cImg7 from "../images/casestudy/img07.jpg";
import cImg8 from "../images/casestudy/img08.jpg";
import cImg9 from "../images/casestudy/img09.jpg";
import cImg10 from "../images/casestudy/img10.jpg";
// Latest - Dev
import dev01 from "../images/casestudy/Kanhiyaswadeshi_website.png";
import dev02 from "../images/casestudy/Aman_Fashion_Tailoring_website.png";
import dev03 from "../images/casestudy/Nahata_Sports_website.png";
import dev04 from "../images/casestudy/dreamstofly_website.png";
import dev05 from "../images/casestudy/justclick_properties_website.png";

// Latest - Design
import des1 from "../images/casestudy/wademo.jpg";
import des2 from "../images/casestudy/web_dev.jpg";
// Latest - Marketing
import mark1 from "../images/casestudy/crm.jpg";

const caseStudies = [
  // Development
  {
    id: 101,
    category: "dev",
    img: dev01,
    title: "Kanhiya Swadeshi",
    slug: "Development",
  },
  {
    id: 102,
    category: "dev",
    img: dev02,
    title: "Aman Fashion Tailoring website",
    slug: "Development",
  },
  {
    id: 103,
    category: "dev",
    img: dev03,
    title: "Nahata Sports Website",
    slug: "Development",
  },
  {
    id: 104,
    category: "dev",
    img: dev04,
    title: "Dreamstofly Website",
    slug: "Development",
  },
  {
    id: 105,
    category: "dev",
    img: dev05,
    title: "Justclick Properties Website",
    slug: "Development",
  },

  // Design
  {
    id: 201,
    category: "des",
    img: des1,
    title: "Wademo",
    slug: "Post",
  },
  {
    id: 202,
    category: "des",
    img: des2,
    title: "Web Development",
    slug: "Post",
  },
  {
    id: 301,
    category: "marketing",
    img: mark1,
    title: "CRM System",
    slug: "Post",
  },

  // {
  //   id: 1,
  //   category: "cat4",
  //   img: cImg1,
  //   title: "SEO tracking analysis..",
  //   slug: "Branding",
  // },
  // {
  //   id: 2,
  //   category: "cat3",
  //   img: cImg2,
  //   title: "Online media management..",
  //   slug: "Marketing",
  // },
  // {
  //   id: 3,
  //   category: "cat4",
  //   img: cImg3,
  //   title: "Cloud infrastructure..",
  //   slug: "Branding",
  // },
  // {
  //   id: 4,
  //   category: "cat2",
  //   img: cImg4,
  //   title: "Design system & UI kit..",
  //   slug: "Design",
  // },
  // {
  //   id: 5,
  //   category: "cat1",
  //   img: cImg5,
  //   title: "Offline SEO marketing..",
  //   slug: "Development",
  // },
  // {
  //   id: 6,
  //   category: "cat5",
  //   img: cImg6,
  //   title: "IT security enhancement..",
  //   slug: "Support",
  // },
  // {
  //   id: 7,
  //   category: "cat2",
  //   img: cImg7,
  //   title: "Minimalistic bottle logo concept..",
  //   slug: "Design",
  // },
  // {
  //   id: 8,
  //   category: "cat1",
  //   img: cImg8,
  //   title: "Advanced Link Building..",
  //   slug: "Development",
  // },
  // {
  //   id: 9,
  //   category: "cat5",
  //   img: cImg9,
  //   title: "Keyword Research..",
  //   slug: "Strategy",
  // },
  // {
  //   id: 10,
  //   category: "cat4",
  //   img: cImg10,
  //   title: "Creative Logo Design..",
  //   slug: "Branding",
  // },
];
export default caseStudies;
